module.exports = __webpack_public_path__ + "static/Capex-CS-958a8294d7ed7c2e5b0810972f364870.jpg";